export const sessionResultsNavigation = {
    namespaced: true,

    state: {
        activeTab: ''
    },

    getters: {
        activeTab(state) {
            return state.activeTab;
        }
    },

    mutations: {
        updateTab(state, data) {
            state.activeTab = data;
        }
    }
};

export default sessionResultsNavigation;
